/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { memo, useContext, useEffect, useState } from 'react';
import {
	Drawer,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Typography,
	Button,
	FormGroup,
	Checkbox,
	Stack,
	Divider,
	Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MdClose } from 'react-icons/md';
import { LanguageContext } from '../../../libs/Context';
import { FilterData } from '../../../containers/actions/networks_revised';
import { useSelector } from 'react-redux';
import Loading from '../Loaders/FullWidthLoader/Loading';
import useGetRelIndData from '../../../containers/NewsFeedRevised/Components/CustomHooks/useGetRelIndD';
import useDidMountEffect from '../../../containers/ContentManagement/CustomHooks/useDidMount';

const FilterSlider = (props:any) =>
{
	const { isDrawerOpen, handleApplyFilter, selectedFilterOptions, filterType, tabValue, handleClose, newsFeedFilterFuction, relationsList, industryList } = props;
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ filterOptions, setFilterOptions ] = useState<any>({});
	const [ loading, setLoading ] = useState(false);
	const [ selectedOptions, setSelectedOptions ] = useState<any>(selectedFilterOptions ?? {});
	const [ accordionData, setAccordionData ] = useState<any>([]);
	const getFiltrData = useGetRelIndData();

	useDidMountEffect(() =>
	{
		if (Object.keys(selectedFilterOptions)?.length > 0)
		{
			setSelectedOptions(selectedFilterOptions);
		}
	}, [ selectedFilterOptions ]);

	const followTypeValues = {
		Follower          : filterOptions?.followersCount ?? 0,
		Following         : filterOptions?.followingCount ?? 0,
		companies         : filterOptions?.companyCount ?? 0,
		'Individual User' : filterOptions?.individualCount ?? 0
	};

	const filterTypeValues = {
		0 : 'connections',
		1 : 'following',
		2 : 'block'
	};

	const [ expanded, setExpanded ] = useState<any>([]);

	const handleAccordianData = (data) =>
	{
		let acc:any = [];

		if (filterType === 'network')
		{
			if (tabValue === 1 || userData?.role === 'individual')
			{
				acc.push({
					label   : language?.FollowType,
					content : [ 'Follower', 'Following', { divider: true }, 'companies', 'Individual User' ],
					key     : 'followType'
				});
			}

			if (tabValue === 0 && userData?.role !== 'individual')
			{
				acc.push({
					label   : language?.relationType,
					content : data?.relations,
					key     : 'relations'
				},
				{
					label   : language?.Invitationtype,
					content : [ 'Sent', 'Received' ],
					key     : 'request'
				});
			}

			if (data?.industryTypes?.length > 0)
			{
				acc.push({
					label   : language?.industryType,
					content : data?.industryTypes,
					key     : 'industries'
				});
			}

			if (data?.countriesList?.length > 0)
			{
				acc.push({
					label   : language?.country,
					content : data?.countriesList,
					key     : 'countries'
				});
			}
		}
		else if (filterType === 'newsfeeds')
		{
			acc = [
				{ label: language?.relationType, content: data?.relations?.map((item:any) => item?.relation) ?? [], key: 'relations' },
				{ label: language?.industryType, content: data?.industryTypes ?? [], key: 'industry' }
			];
		}

		const openAccrdns = acc?.map((_, index) => index);

		setExpanded(openAccrdns);
		setAccordionData(acc);
	};

	// let accordionData;

	// else
	// {
	// 	accordionData = [];
	// }

	const handleAccordionChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) =>
	{
		setExpanded((prevExpanded) =>
			(isExpanded ? [ ...prevExpanded, panel ] : prevExpanded.filter((expandedPanel) => expandedPanel !== panel))
		);
	};

	const isDivider =
	(option: string | { divider: boolean }): option is { divider: boolean } =>
	{
		return (option as { divider: boolean }).divider !== undefined;
	};

	const handleCheckbox = (key, value) =>
	{
		const updateSelectedResn = selectedOptions[key]?.includes(value)
			? selectedOptions[key]?.filter((item) => item !== value)
			: [ ...(selectedOptions[key] || []), value ];

		setSelectedOptions((prev) =>
		{
			const newState = { ...prev };

			if (updateSelectedResn?.length === 0)
			{
				delete newState[key];
			}
			else
			{
				newState[key] = updateSelectedResn;
			}

			return newState;
		});
	};

	const handleClear = (key) =>
	{
		setSelectedOptions((prev) =>
		{
			const newState = { ...prev };

			delete newState[key];

			return newState;
		});
	};

	const getFliterData = async () =>
	{
		const query = {
			companyId : userData?.companyId,
			empRole   : userData?.empRole,
			type      : userData?.role === 'individual' ? 'following' : filterTypeValues[tabValue]
		};

		try
		{
			setLoading(true);
			const res = await FilterData(query);

			if (res?.status)
			{
				setFilterOptions(res?.data);
				handleAccordianData(res?.data);
			}
			else
			{
				setFilterOptions({});
			}
		}
		catch (err)
		{
			console.log(err, '=============================>');
		}
		finally
		{
			setLoading(false);
		}
	};

	const newsFeedFilterFun = async () =>
	{
		newsFeedFilterFuction();

		handleAccordianData({ relations: relationsList, industryTypes: industryList });
	};

	useEffect(() =>
	{
		if (filterType === 'network')
		{
			getFliterData();
		}
		else
		{
			newsFeedFilterFun();
		}
	}, []);

	const isButtonEnabled = Object?.keys(selectedFilterOptions)?.length > 0
		? JSON.stringify(selectedFilterOptions) !== JSON.stringify(selectedOptions)
		: Object.values(selectedOptions)?.length > 0 &&
	Object.values(selectedOptions)?.some((arr) => Array.isArray(arr) && arr?.length > 0);

	const handleParentClose = (e, reason) =>
	{
		if (reason === 'backdropClick')
		{
			return;
		}

		handleClose();
	};

	return (
		<Drawer
			anchor='right'
			open={isDrawerOpen}
			onClose={(event, reason) => handleParentClose(event, reason)}
			PaperProps={{
				sx : {
					width : {
						xs : 'var(--percent100)',
						sm : '70%',
						md : '30%',
						lg : '30%'
					},
					display       : 'flex',
					flexDirection : 'column'
				}
			}}
		>
			{loading && <Loading />}
			<Stack
				direction={'row'}
				alignItems={'center'}
				p='var(--pixel8)'
				bgcolor={'var(--baseColor)'}
				justifyContent='space-between'
				sx={{
					position        : 'sticky',
					top             : 0,
					zIndex          : 1,
					backgroundColor : 'var(--baseColor)',
					borderBottom    : '1px solid var(--grayE0)'
				}}
			>
				<Typography variant='h6' pl='var(--pixel8)'>
					{language?.filter}
				</Typography>
				<Stack direction='row' alignItems='center'>
					{Object?.keys(selectedOptions)?.length > 0 &&
					<Button
						onClick={() => setSelectedOptions({})}
						variant='text'
						size='small'
						sx={{ textTransform: 'none', fontSize: 'var(--pixel16)' }}
					>
						{language?.reset}
					</Button>}
					<MdClose onClick={handleClose} style={{ fontSize: 'var(--pixel20)', cursor: 'pointer' }} />
				</Stack>
			</Stack>
			{/* Accordions for Filters */}
			<Box style={{ flex: 1, overflowY: 'auto' }}>
				{accordionData?.map((item, index) => (
					(item?.content?.length > 0 &&
					<Accordion
						key={index}
						disableGutters
						elevation={0}
						expanded={expanded?.includes(index)}
						onChange={handleAccordionChange(index)}
						sx={{
							'&:before' : {
								display : 'none'
							},
							borderBottom : index === accordionData.length - 1 ? 'none' : '1px solid var(--grayE0)',
							width        : 'var(--percent100)',
							borderRadius : '0px !important'
						}}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							sx={{
								display         : 'flex',
								justifyContent  : 'space-between',
								height          : '54px',
								margin          : '0 !important',
								backgroundColor : expanded?.includes(index) ? '#E7F6FA' : 'transparent'
							}}
						>
							<Stack direction='row' alignItems='center' spacing={1} sx={{ flexGrow: 1 }}>
								<Typography variant='body1' fontWeight='var(--font500)' sx={{ textTransform: 'capitalize' }}>
									{item?.label}
								</Typography>
								{selectedOptions[item?.key]?.length > 0 && (
									<Button
										size='small'
										variant='contained'
										sx={{ color        : '#ffffff',
											minWidth     : '6px',
											height       : 'var(--pixel18)',
											width        : 'var(--pixel18)',
											padding      : '0px 10px',
											boxShadow    : 'none',
											borderRadius : '2px',
											'&:hover'    : {
												boxShadow : 'none'
											} }}
									>
										{selectedOptions[item?.key]?.length}
									</Button>
								)}
							</Stack>
							{selectedOptions[item?.key]?.length > 0 && (
								<Button
									variant='text'
									sx={{ textTransform: 'none', fontSize: 'var(--pixel16)' }}
									onClick={(e) => { e?.stopPropagation(); handleClear(item?.key); }}
								>
									{language?.clear}
								</Button>
							)}
						</AccordionSummary>
						<AccordionDetails
							sx={{
								fontSize   : 'var(--pixel16)',
								fontWeight : 400
							}}
						>
							<FormGroup>
								{item?.content?.length > 0 && item?.content?.map((option, idx) =>
									(isDivider(option)
										? (
											<Divider key={idx} sx={{ my: 1 }} />
										)
										: (
											<Box key={idx} sx={{ display: 'flex', alignItems: 'center', cursor: 'default' }}>
												<Checkbox
													name={item?.key}
													checked={selectedOptions[item?.key]?.includes(option) ?? false}
													onChange={() => handleCheckbox(item?.key, option)}
												/>
												<Typography variant='body1' sx={{ ml: 1, textTransform: 'capitalize' }}>
													{item.label !== language?.FollowType ? option : `${option} (${followTypeValues[option]})`}
												</Typography>
											</Box>
										))
								)}
							</FormGroup>
						</AccordionDetails>
					</Accordion>)
				))}
			</Box>

			<Stack
				direction={'row'}
				spacing={2}
				justifyContent={'flex-end'}
				width={'var(--percent100)'}
				p='var(--pixel24)'
				sx={{
					position        : 'sticky',
					bottom          : 0,
					backgroundColor : 'var(--whiteColor)',
					borderTop       : '1px solid var(--grayE0)'
				}}
			>
				<Button variant='outlined' sx={{ textTransform: 'none' }} onClick={handleClose}>
					{language?.cancel}
				</Button>
				<Button
					variant='contained'
					className={!isButtonEnabled ? 'buttonBg disableMode' : 'buttonBg'}
					sx={{ color: '#ffffff', textTransform: 'none' }}
					disabled={JSON.stringify(selectedFilterOptions) === JSON.stringify(selectedOptions)}
					onClick={() => handleApplyFilter(selectedOptions)}
				>
					{language?.apply}
				</Button>
			</Stack>
		</Drawer>
	);
};

export default memo(FilterSlider);
